<template>
  <el-popover
    v-model="visible"
    :width="popoverWidth"
    placement="bottom-start"
    trigger="click"
    style="padding-left: 0; padding-right: 0px;"
  >
    <layout-flex direction="row" style="height: 400px; margin: 0 -12px;">
      <template v-slot:fillWrapper>
        <flex-item v-for="(it, idx) in itemList" :key="idx">
          <check-list
            :items="it"
            :allowed-check="false"
            :is-leaf="idx + 1 >= deep"
            @click="(p) => handleSelected(p, idx)"
          />
        </flex-item>
      </template>
    </layout-flex>
    <div
      slot="reference"
      @mouseenter="hover = true"
      @mouseleave="hover = false"
      class="flex flex-row"
      style="
        position: relative;
        border: 1px solid #cccccc;
        border-radius: 5px;
        min-height: 21px;
        max-height: 80px;
      "
    >
      <div class="flex-fill">
        <el-input
          size="mini"
          :value="showPrefix ? tag.fullName : tag.name"
          class="search-box"
          style="flex: 1; display: block; min-width: 50px;"
          :placeholder="placeholder"
        />
      </div>
      <div class="flex flex-auto" style="padding: 5px;">
        <i
          v-if="hover && tag.id"
          class="el-icon-circle-close select-suffix"
          @click.stop="handleCleanAll"
        />
        <i v-else-if="visible" class="el-icon-arrow-up select-suffix" />
        <i v-else class="el-icon-arrow-down select-suffix" />
      </div>
    </div>
  </el-popover>
</template>
<script>
import { Menu, MenuItem } from "element-ui";
import { CheckboxGroup, Checkbox } from "element-ui";
import { Input, Popover, Tag, Icon } from "element-ui";
import LayoutFlex from "@/components/layout/Flex";
import FlexItem from "@/components/layout/FlexItem";
import CheckList from "@/components/list/CheckList";
import "@/utils/extensions/libs/ArrayExtension";
import { AreaSharedCache } from "@/utils/AreaSharedCache";
import {
  assembleAreaDisabled,
  filterAreaAllowed,
  filterAreaHidden,
} from "@/utils/excel/OptionFilter";

const equalValue = (left, right) => {
  return `${left}` === `${right}`;
};
const findToRemoveItem = (oldList, newList) => {
  if (!Array.isArray(oldList) || !oldList.length) {
    return [];
  }
  if (!Array.isArray(newList) || !newList.length) {
    return oldList.map((it) => it.id);
  }
  return oldList
    .filter((old) => {
      return !newList.some((it) => equalValue(it.id, old.id));
    })
    .map((it) => it.id);
};
export default {
  name: "area-cascade-selector",
  components: {
    CheckList,
    FlexItem,
    LayoutFlex,
    [Menu.name]: Menu,
    [MenuItem.name]: MenuItem,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Input.name]: Input,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Popover.name]: Popover,
  },
  props: {
    provinces: {
      type: Array,
    },
    showPrefix: {
      type: Boolean,
      default: false,
    },
    separator: {
      type: String,
      default: "/",
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    value: {
      type: Array,
    },
    allowedValues: {
      type: Array,
    },
    hiddenValues: {
      type: Array,
    },
    disabledValues: {
      type: Array,
    },
    deep: {
      type: Number,
      default: 3,
      validator(value) {
        return [2, 3].includes(value);
      },
    },
  },
  model: {
    prop: "value",
    event: "change",
  },
  data() {
    return {
      itemList: [],
      tag: {},
      wrapperHeight: 21,
      maxHeight: 80,
      visible: false,
      hover: false,
    };
  },
  computed: {
    popoverWidth() {
      return this.itemList.length * 200 + 20;
    },
  },
  mounted() {
    const list = this.filterProvinces(this.$props.provinces || []);
    this.itemList = [list];
    this.updateValue(this.$props.value);
  },
  watch: {
    provinces(provinces) {
      const list = this.filterProvinces(provinces || []);
      this.removeExpiredChecked(this.itemList[0], provinces);
      this.itemList = [list];
    },
    value(value) {
      //todo: 初始化标题
      this.updateValue(value);
      this.updateTags();
    },
  },
  methods: {
    obtainItems(items, deepIndex) {
      if (Array.isArray(items)) {
        return items.map((it) => it[deepIndex]);
      }
      return null;
    },
    obtainArrayItems(items, deepIndex) {
      if (Array.isArray(items)) {
        return items.flatMap((it) => it[deepIndex]);
      }
      return null;
    },
    filterProvinces(provinces) {
      if (!Array.isArray(provinces) || !provinces.length) {
        return provinces;
      }
      const { disabledValues, hiddenValues, allowedValues } = this.$props;
      const list = filterAreaAllowed(
        provinces,
        this.obtainItems(allowedValues, 0)
      );
      const filter = filterAreaHidden(list, this.obtainItems(hiddenValues, 0));
      return assembleAreaDisabled(filter, this.obtainItems(disabledValues, 0));
    },
    filterAllowedAreas(items, deepIndex) {
      if (!Array.isArray(items) || !items.length) {
        return items;
      }
      const { disabledValues, hiddenValues, allowedValues } = this.$props;
      const list = filterAreaAllowed(
        items,
        this.obtainArrayItems(allowedValues, deepIndex)
      );
      const filter = filterAreaHidden(
        list,
        this.obtainArrayItems(hiddenValues, deepIndex)
      );
      return assembleAreaDisabled(
        filter,
        this.obtainArrayItems(disabledValues, deepIndex)
      );
    },
    updateValue(value) {
      if (Array.isArray(value)) {
        this.selectedList = value;
      } else {
        this.selectedList = [];
      }
    },
    updateTags() {
      const { separator } = this.$props;
      const array = this.selectedList.map((it) => {
        const item = AreaSharedCache.getItem(it);
        return (item && item.name) || it;
      });
      const fullName = array.join(separator);
      const name = array[array.length - 1];
      const id = this.selectedList[this.selectedList.length - 1];
      this.tag = { id, name, fullName };
    },
    async handleSelected({ value, isLeaf }, deepIndex) {
      if (isLeaf) {
        console.log("我选择了这个", value);
        this.selectedList = this.selectedList
          .slice(0, deepIndex)
          .concat([value]);
        this.updateTags();
        this.emitChangeValue([...this.selectedList]);
        this.visible = false;
        return;
      }
      if (this.selectedList[deepIndex] === value) {
        return;
      }
      const children = await AreaSharedCache.loadChildren(value);
      const allowedChildren = this.filterAllowedAreas(children, deepIndex + 1);
      this.itemList = this.itemList
        .slice(0, deepIndex + 1)
        .concat([allowedChildren]);
      this.selectedList = this.selectedList.slice(0, deepIndex).concat([value]);
    },
    handleCleanAll() {
      this.selectedList = [];
      this.updateTags();
      this.emitChangeValue(this.selectedList);
    },
    removeExpiredChecked(oldList, newList) {
      const province = this.selectedList[0];
      if (province && !newList.some((it) => it.id === province)) {
        this.selectedList = [];
      }
    },
    emitChangeValue(value) {
      this.$emit("change", value);
    },
  },
};
</script>
<style scoped>
.search-box >>> input {
  border: none;
  /*min-width: 50px;*/
}
.select-suffix {
  display: inline-flex;
  align-self: center;
}
</style>
